import React from "react";

function IotTypeStep({ handleChange, formData }) {
  return (
    <>
      <div className="row pb-5 pb-sm-5 pb-md-5 pb-lg-5 pb-xl-5">
        <div className="col-lg-12">
          <div className="pt-3 mt-3">
            <h2 className="h6 pb-1 mb-3 color_grey">
              Great! Let’s Narrow This Step Down.
            </h2>
            {/* Required Field: Must choose one. */}
            <div className="nav nav-pills row row-cols-2 row-cols-sm-3 row-cols-md-3 gap-0 g-3">
              {/* Industrial IoT */}
              <div className="col">
                <input
                  type="radio"
                  className="btn-check"
                  id="industry"
                  name="iot-category"
                  value="Industrial IoT"
                  onChange={handleChange}
                  checked={formData["iot-category"] === "Industrial IoT"}
                />
                <label
                  className="nav-link flex-column w-100 align-items-center gap-2 rounded p-3"
                  htmlFor="industry"
                >
                  <img
                    className="main__icon"
                    src="/assets/icons/industry.svg"
                    alt="Industrial IoT"
                  />
                  <div className="main_card_info">
                    <h3>Industrial IoT</h3>
                    <p>
                      Smart Machines, Sensors, Intelligent Controllers,
                      Real-Time Monitoring, etc.
                    </p>
                  </div>
                </label>
              </div>

              {/* Medical IoT */}
              <div className="col">
                <input
                  type="radio"
                  className="btn-check"
                  id="medical"
                  name="iot-category"
                  value="Medical IoT"
                  onChange={handleChange}
                  checked={formData["iot-category"] === "Medical IoT"}
                />
                <label
                  className="nav-link flex-column w-100 align-items-center gap-2 rounded p-3"
                  htmlFor="medical"
                >
                  <img
                    className="main__icon"
                    src="/assets/icons/medical.svg"
                    alt="Medical IoT"
                  />
                  <div className="main_card_info">
                    <h3>Medical IoT</h3>
                    <p>
                      Remote Health Monitoring, Emergency Notification Systems,
                      Wearable IoT Devices, etc.
                    </p>
                  </div>
                </label>
              </div>

              {/* Environmental Monitoring */}
              <div className="col">
                <input
                  type="radio"
                  className="btn-check"
                  id="environment-analysis"
                  name="iot-category"
                  value="Environmental Monitoring"
                  onChange={handleChange}
                  checked={
                    formData["iot-category"] === "Environmental Monitoring"
                  }
                />
                <label
                  className="nav-link flex-column w-100 align-items-center gap-2 rounded p-3"
                  htmlFor="environment-analysis"
                >
                  <img
                    className="main__icon"
                    src="/assets/icons/cevre_analizi.svg"
                    alt="Environmental Monitoring"
                  />
                  <div className="main_card_info">
                    <h3>Environmental Monitoring</h3>
                    <p>
                      Noise and Air Pollution Monitoring, Fire Detection
                      Systems, Earthquake and Tsunami Early Warning Systems,
                      etc.
                    </p>
                  </div>
                </label>
              </div>

              {/* Energy Sector */}
              <div className="col">
                <input
                  type="radio"
                  className="btn-check"
                  id="energy"
                  name="iot-category"
                  value="Energy Sector"
                  onChange={handleChange}
                  checked={formData["iot-category"] === "Energy Sector"}
                />
                <label
                  className="nav-link flex-column w-100 align-items-center gap-2 rounded p-3"
                  htmlFor="energy"
                >
                  <img
                    className="main__icon"
                    src="/assets/icons/energy.svg"
                    alt="Energy Sector"
                  />
                  <div className="main_card_info">
                    <h3>Energy Sector</h3>
                    <p>
                      Smart Grids, Advanced Metering Infrastructure, SCADA,
                      Smart Inverters, etc.
                    </p>
                  </div>
                </label>
              </div>

              {/* Transportation */}
              <div className="col">
                <input
                  type="radio"
                  className="btn-check"
                  id="transport"
                  name="iot-category"
                  value="Transportation"
                  onChange={handleChange}
                  checked={formData["iot-category"] === "Transportation"}
                />
                <label
                  className="nav-link flex-column w-100 align-items-center gap-2 rounded p-3"
                  htmlFor="transport"
                >
                  <img
                    className="main__icon"
                    src="/assets/icons/transport.svg"
                    alt="Transportation"
                  />
                  <div className="main_card_info">
                    <h3>Transportation</h3>
                    <p>
                      Smart Traffic, Autonomous Navigation, Inter and Intra
                      Vehicle Communication, Smart Parking, etc.
                    </p>
                  </div>
                </label>
              </div>

              {/* Building Automation */}
              <div className="col">
                <input
                  type="radio"
                  className="btn-check"
                  id="smart-home"
                  name="iot-category"
                  value="Building Automation"
                  onChange={handleChange}
                  checked={formData["iot-category"] === "Building Automation"}
                />
                <label
                  className="nav-link flex-column w-100 align-items-center gap-2 rounded p-3"
                  htmlFor="smart-home"
                >
                  <img
                    className="main__icon"
                    src="/assets/icons/smart-home.svg"
                    alt="Building Automation"
                  />
                  <div className="main_card_info">
                    <h3>Building Automation</h3>
                    <p>
                      Smart Lighting, Energy Management, Climate Control,
                      Security Systems, etc.
                    </p>
                  </div>
                </label>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
}

export default IotTypeStep;
